import { render, staticRenderFns } from "./EmptyChatBox.vue?vue&type=template&id=353d79c4&scoped=true"
import script from "./EmptyChatBox.vue?vue&type=script&lang=js"
export * from "./EmptyChatBox.vue?vue&type=script&lang=js"
import style0 from "./EmptyChatBox.vue?vue&type=style&index=0&id=353d79c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d79c4",
  null
  
)

export default component.exports